import React from 'react';
import * as _ from 'lodash';
import { SPOT_STATUS } from '../../../utilities/constants';
import { MachineryUseService } from '../../../services/MachineryUses';
import { messageUtility } from '../../../utilities/messageUtility';
import { FormElement, FormDropdownRadio } from '../../CommonFormComponents';
/**
 * 機材予定履歴取得ドロップダウン
 * @param set {function} 選択した値
 */
export class MachineryUseSpotHistoryDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldId: sessionStorage.getItem('field_id'),
      opened: false, // 開閉フラグ
      selected: null, // 選択したID
      options: {}, // 選択肢
      error: '', // バリデーションメッセージ
    };

    // ユニークID生成
    this.id = _.uniqueId();
    this.handleOpen = this.handleOpen.bind(this); // 開閉イベント
    this.handleSelectedRow = this.handleSelectedRow.bind(this); // 選択肢クリックイベント
    this.getHistories = this.getHistories.bind(this); // 車両名取得
    this.parent = React.createRef();
    this.handleClickOutsideOfComponent = this.handleClickOutsideOfComponent.bind(
      this
    );
  }

  componentDidMount() {
    this.getHistories(() => {});
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(props, state) {
    if (this.state.opened) {
      // ドロップダウンが可視状態になった場合は、documentにコンポーネント外をclickしたかのイベントを追加する
      document.addEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (!this.state.opened) {
      // ドロップダウンが不可視状態になった場合は、documentのclickイベントを削除する
      document.removeEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
  }

  handleClickOutsideOfComponent = e => {
    // コンポーネント内クリックの場合は無視する
    if (
      !_.isNull(this.parent.current) &&
      this.parent.current.contains(e.target)
    ) {
      return;
    }
    // コンポーネント外クリックの場合はドロップダウンを不可視とする
    // イベントはstateにfalseが設定された際にremoveされる
    this.setState({ opened: false });
  };
  /**
   * 開閉イベント
   */
  handleOpen = () => {
    this.setState({ opened: !this.state.opened });
  };

  /**
   * 選択肢クリックイベント
   * @param id {int} 選択したデータID
   * @param checked {bool}
   */
  handleSelectedRow = (id, checked) => {
    let selected = null;
    if (checked) {
      selected = id;
    }
    this.setState({ selected, opened: false });
    this.props.set('spot_company_name', selected);
  };

  /**
   * 車両名履歴取得
   */
  getHistories() {
    MachineryUseService.spotHistoryList(this.state.fieldId).then(response => {
      if (response.result) {
        const histories = response.data.entities.histories;
        let options = {};
        if (!_.isEmpty(histories)) {
          _.each(histories, history => {
            options[history.id] = history;
          });
        }
        this.setState({ options });
      }
    });
  }

  render() {
    return (
      <FormElement validate={this.props.error}>
        <input
          name='spot_company_name'
          type='text'
          disabled={this.props.readOnly}
          maxLength={255}
          onChange={e => this.props.set('spot_company_name', e.target.value)}
          value={this.props.value}
          onBlur={e => this.props.validate(e.target.name)}
        />
        {!this.props.readOnly && (
          <div
            id='form-dropdown'
            className='dropdown-multi-select dropdown-multi-select__history-search'
            ref={this.parent}
          >
            <div className='dropdown-multi-select__header'>
              <button
                id='form-dropdown-btn'
                className='btn-fixedsize--sub'
                onClick={() => this.handleOpen()}
              >
                履歴から選択
              </button>
            </div>
            {this.state.opened && (
              <div
                id='form-dropdown-list'
                className={'dropdown dropdown--dropdown-list show'}
              >
                <div className='dropdown__item dropdown__item--wide dropdown__item--hidden'>
                  <div className='dropdown-single-select__item'>
                    <div className='dropdown-single-select__scroll'>
                      <ul className='single-select'>
                        {_.isEmpty(this.state.options) ? (
                          <div className='table-has-no-data'>
                            <div className='table-has-no-data__message'>
                              {messageUtility.getMessage('I-000-046')}
                            </div>
                          </div>
                        ) : (
                          _.map(this.state.options, (option, index) => (
                            <FormDropdownRadio
                              key={index}
                              option={option}
                              checked={
                                this.state.selected === option.spot_company_name
                              }
                              targetId={this.id}
                              handleSelectedRow={this.handleSelectedRow}
                              forId='single-machinery-latest-registration-history'
                              column='spot_company_name'
                            >
                              {option.spot_company_name}
                            </FormDropdownRadio>
                          ))
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        {!this.props.readOnly && (
          <span
            className='btn-text'
            onClick={() => this.props.events(SPOT_STATUS.normal.id)}
          >
            解除
          </span>
        )}
      </FormElement>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/MachineryUseSpotHistory.jsx